import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=f0cd2a70&"
import script from "./origin.vue?vue&type=script&lang=js&"
export * from "./origin.vue?vue&type=script&lang=js&"
import style0 from "./origin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports